<template>
  <div id="bigScreem">
    <ABigScreemTitle></ABigScreemTitle>
    <ABigScreemTop
      v-bind:leftData="leftData"
      v-bind:centerData="centerData"
      v-bind:rightData="rightData"
    />
    <ABigScreemCenter
      v-bind:barData="barData"
      v-bind:line_data_date="line_data_date"
      v-bind:line_data_num="line_data_num"
      v-bind:percent_blood_pressure="percent_blood_pressure"
      v-bind:percent_blood_sugar="percent_blood_sugar"
    />
    <ABigScreemBottom
      v-bind:bottomData="bottomData"
      v-bind:orgReportCount="orgReportCount"
      v-bind:orgReportLookCount="orgReportLookCount"
    />
  </div>
</template>

<script>
import ABigScreemTop from "@/view/pages/bigScreem/ABigScreemTop";
import ABigScreemTitle from "@/view/pages/bigScreem/ABigScreemTitle";
import ABigScreemCenter from "@/view/pages/bigScreem/ABigScreemCenter";
import ABigScreemBottom from "@/view/pages/bigScreem/ABigScreemBottom";

import DashApi from "@/model/api/dashboard";
export default {
  name: "",
  components: {
    ABigScreemTitle,
    ABigScreemTop,
    ABigScreemCenter,
    ABigScreemBottom
  },
  data() {
    return {
      // top Data
      leftData: [],
      centerData: [],
      rightData: [],

      // center Charts Data
      barData: {},
      line_data_date: [],
      line_data_num: [],
      percent_blood_pressure: "",
      percent_blood_sugar: "",
      // bottomData
      bottomData: [],
      orgReportCount: "",
      orgReportLookCount: "",
    };
  },
  mounted: function() {
    DashApi.getBigScreemData().then(res => {
      // console.log(res);
      var rData = res.data.data;

      this.handleTopData(rData);
      this.handleCenterData(rData);
      this.handleBottomData(rData);
    });
  },
  methods: {
    handleTopData(r) {
      const leftData = [
        { key: "当日新增居民", value: r.todayUserNum, unit: "人" },
        { key: "当日检测居民", value: r.todayUserCheckNum, unit: "人" },
        { key: "当日血糖检测次数", value: r.todayBloodSugarCount, unit: "次" },
        {
          key: "当日血压检测次数",
          value: r.todayBloodPressureCount,
          unit: "次"
        }
      ];
      this.leftData = leftData;

      const centerData = [
        { key: "当日检测人次", value: r.todayUserNum, unit: "人次" },
        { key: "累计检测人次", value: r.todayUserCheckNum, unit: "人次" }
      ];
      this.centerData = centerData;

      const rightData = [
        {
          key: "当日血压异常居民数",
          value: r.todayBloodPressureErrorNum,
          unit: "人"
        },
        {
          key: "当日血糖异常居民数",
          value: r.todayBloodSugarErrorNum,
          unit: "人"
        },
        {
          key: "当日血压异常次数",
          value: r.todayBloodPressureErrorCount,
          unit: "次"
        },
        {
          key: "当日血糖异常次数",
          value: r.todayBloodSugarErrorCount,
          unit: "次"
        }
      ];
      this.rightData = rightData;
    },
    handleCenterData(r) {
      this.barData = r.timeResult;
      this.line_data_date = r.line_data.date;
      this.line_data_num = r.line_data.num;
      this.percent_blood_sugar = r.percent_blood_sugar;
      this.percent_blood_pressure = r.percent_blood_pressure;
      // this.percent_blood_sugar = 0.3
      // this.percent_blood_pressure = 0.9
    },
    handleBottomData(r) {
      var arr = [];

      for (var index in r.list_data) {
        let item = r.list_data[index];
        var t = [];
        t.push(index);
        t.push(item.check_time);
        t.push(item.username);
        t.push(item.age);
        t.push(item.gender);
        t.push(item.type);
        t.push(item.result);
        arr.push(t);
      }
      console.log(arr);
      this.bottomData = arr;

      this.orgReportCount = r.orgReportCount;
      this.orgReportLookCount = r.orgReportLookCount;
    }
  }
};
</script>

<style scoped>
#bigScreem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  min-width: 1920px;
  background-image: url("~@/assets/images/bigScreem/background.png");
}

.aContent > div {
  width: 100%;
}
</style>
